import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "dropdown", "hiddenField", "currentColor"];
  static values = { selected: String };

  connect() {
    // Close dropdown when clicking outside
    this.boundClose = this.close.bind(this);
    document.addEventListener("click", this.boundClose);
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose);
  }

  toggle(event) {
    event.stopPropagation();
    this.dropdownTarget.classList.toggle("hidden");
  }

  select(event) {
    const colorId = event.currentTarget.dataset.colorId;
    const hexCode = event.currentTarget.dataset.hexCode;

    // Update hidden field
    this.hiddenFieldTarget.value = colorId;

    // Update current color display
    this.currentColorTarget.style.backgroundColor = hexCode;

    // Close dropdown
    this.closeDropdown();
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdown();
    }
  }

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden");
  }
}
